import React from 'react';
import './settings.css'
import pic35 from '../../assets/pic35.png'
import pic36 from '../../assets/pic36.png'
import pic38 from '../../assets/pic38.png'
import pic41 from '../../assets/pic41.png'
import PrimaryctaLongsettings from './settings-primary-cta';
import SecondaryctaLongsettings from './settings-secondary-cta';
import AudioContext from './AudioContext';
import pic45 from '../../assets/pic45.png'
import pic46 from '../../assets/pic46.png'
import pic47 from '../../assets/pic47.png'
import './how to play.css'
import PrimaryctaLong from './primary cta long';
import HowToPlayAudio from '../../audio/How to Play.mp4';
import { useEffect } from 'react';
import { useState } from 'react';

const Howtoplay = ({ onClose }) => {
    const [closing, setClosing] = useState(false);
    const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = soundVolume;
        audio.play().catch(() => {});

        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);

    useEffect(() => {
        if (audioRef.current) audioRef.current.volume = soundVolume;
    }, [soundVolume]);


    const handleClose = () => {
        setClosing(true);
        setTimeout(() => onClose(), 400);
    };

    return ( 
        <>
          <audio ref={audioRef} src={HowToPlayAudio} preload="auto" />

            <section  className={`settings-background ${closing ? 'slide-down' : ''}`} onClick={handleClose}>
                <section  className='howtoplay-overlay' onClick={e => e.stopPropagation()}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>How to play</h2>
                        <h2 className='title2-container-settings'>How to play</h2>
                    </div>
                    <button className='circlecta-cont'   onClick={handleClose}>
                    <div className='circle-red'>
                            <img className='close-img' src={pic35} alt='close'></img>
                    </div>
                    </button>
                </section>


                <section className='container-howtoplay'>
                    <section className='container-audio'>
                            <section className='row-audio'>
                               <img src={pic45} alt='movement'></img>
                                <h2 className='text-how-to-play'>Move left & right to the end</h2>
                            </section>

                            <section className='row-audio'>
                               <img src={pic46} alt='movement'></img>
                                <h2 className='text-how-to-play'>Avoid Touching Obstacles</h2>
                            </section>

                            <section className='row-audio'>
                               <img src={pic47} alt='movement'></img>
                                <h2 className='text-how-to-play'>Collect All Artifacts  </h2>
                            </section>


                    </section>
                </section>



                <div className='container-continue' onClick={handleClose}>
                    <PrimaryctaLong title='Continue'/>
                </div>



                </section>
            </section>
        </>
     );
}
 
export default Howtoplay;